import React, { Component } from "react";
import { Link } from "react-router-dom";

import project1 from "../assets/img/project-1.jpg";
import project2 from "../assets/img/project-2.jpg";
import project3 from "../assets/img/project-3.jpg";
import project4 from "../assets/img/project-4.jpg";
import project5 from "../assets/img/project-5.jpg";
import project6 from "../assets/img/project-6.jpg";

import { getCMS } from "../services/cmsService";

export class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      aboutData: [],
      contactData: [],
      socialData: [],
    };
  }

  async componentDidMount() {
    try {
      const aboutData = await getCMS("about");
      const contactData = await getCMS("contact");
      const socialData = await getCMS("socialmedia");

      this.setState({
        aboutData,
        contactData,
        socialData,
      });
    } catch (error) {
      console.log(error);
    }
  }

  getContentByType = (data, type) => {
    return data.find(
      (item) => item.content_type === String(type)
    );
  };

  render() {
    const { aboutData, contactData, socialData } = this.state;

    // ABOUT PAGE DATA
    const aboutDescription =
      aboutData.find((item) => item.content_type === "3");

    // CONTACT PAGE DATA
    const address =
      contactData.find((item) => item.content_type === "7");

    const mobile =
      contactData.find((item) => item.content_type === "6");

    const email =
      contactData.find((item) => item.content_type === "5");

    // SOCIAL MEDIA DATA
    const facebook =
      socialData.find(
        (item) =>
          item.content_title?.toLowerCase() === "facebook"
      );

    const instagram =
      socialData.find(
        (item) =>
          item.content_title?.toLowerCase() === "instagram"
      );

    const linkedin =
      socialData.find(
        (item) =>
          item.content_title?.toLowerCase() === "linkedin"
      );

    const youtube =
      socialData.find(
        (item) =>
          item.content_title?.toLowerCase() === "youtube"
      );

    return (
      <div>
        {/* Footer Start */}
        <div className="container-fluid bg-secondary text-white-50 footer pt-5 mt-5">
          <div className="container py-5">
            <div className="row g-5">

              {/* Company Info */}
              <div
                className="col-md-6 col-lg-3 wow fadeIn"
                data-wow-delay="0.1s"
              >
                <Link to="/" className="d-inline-block mb-3">
                  <h1 className="text-white">
                    Ideal Technoride
                  </h1>
                </Link>

                <p className="mb-0">
                  {aboutDescription?.content_paragraph}
                </p>
              </div>

              {/* Contact */}
              <div
                className="col-md-6 col-lg-3 wow fadeIn"
                data-wow-delay="0.3s"
              >
                <h4 className="text-white mb-4">
                  Get In Touch
                </h4>

                <p>
                  <i className="fa fa-map-marker-alt me-3"></i>
                  {address?.content_paragraph}
                </p>

                <p>
                  <i className="fa fa-phone-alt me-3"></i>
                  {mobile?.content_title}
                </p>

                <p>
                  <i className="fa fa-envelope me-3"></i>
                  {email?.content_title}
                </p>

                <div className="d-flex pt-2">

                  {facebook && (
                    <a
                      className="btn btn-primary btn-square me-2"
                      href={facebook.content_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  )}

                  {youtube && (
                    <a
                      className="btn btn-primary btn-square me-2"
                      href={youtube.content_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-youtube"></i>
                    </a>
                  )}

                  {instagram && (
                    <a
                      className="btn btn-primary btn-square me-2"
                      href={instagram.content_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  )}

                  {linkedin && (
                    <a
                      className="btn btn-primary btn-square"
                      href={linkedin.content_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                  )}

                </div>
              </div>

              {/* Popular Links */}
              <div
                className="col-md-6 col-lg-3 wow fadeIn"
                data-wow-delay="0.5s"
              >
                <h4 className="text-white mb-4">
                  Popular Link
                </h4>

                <Link className="btn btn-link" to="/about">
                  About Us
                </Link>

                <Link className="btn btn-link" to="/contact">
                  Contact Us
                </Link>

                <Link className="btn btn-link" to="/privacy">
                  Privacy Policy
                </Link>

                <Link className="btn btn-link" to="/terms">
                  Terms & Conditions
                </Link>

                <Link className="btn btn-link" to="/career">
                  Career
                </Link>
              </div>

              {/* Gallery */}
              <div
                className="col-md-6 col-lg-3 wow fadeIn"
                data-wow-delay="0.7s"
              >
                <h4 className="text-white mb-4">
                  Project Gallery
                </h4>

                <div className="row g-2">
                  <div className="col-4">
                    <img
                      className="img-fluid rounded w-100"
                      src={project1}
                      alt=""
                    />
                  </div>

                  <div className="col-4">
                    <img
                      className="img-fluid rounded w-100"
                      src={project2}
                      alt=""
                    />
                  </div>

                  <div className="col-4">
                    <img
                      className="img-fluid rounded w-100"
                      src={project3}
                      alt=""
                    />
                  </div>

                  <div className="col-4">
                    <img
                      className="img-fluid rounded w-100"
                      src={project4}
                      alt=""
                    />
                  </div>

                  <div className="col-4">
                    <img
                      className="img-fluid rounded w-100"
                      src={project5}
                      alt=""
                    />
                  </div>

                  <div className="col-4">
                    <img
                      className="img-fluid rounded w-100"
                      src={project6}
                      alt=""
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>

          {/* Copyright */}
          <div
            className="container wow fadeIn"
            data-wow-delay="0.1s"
          >
            <div className="copyright">
              <div className="row">

                <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                  &copy;{" "}
                  <Link className="border-bottom" to="/">
                    Ideal Technoride
                  </Link>
                  , All Right Reserved.
                  <br />
                  Designed By{" "}
                  <Link className="border-bottom" to="/">
                    Ideal Technoride
                  </Link>
                </div>

                <div className="col-md-6 text-center text-md-end">
                  <div className="footer-menu">
                    <Link to="/">Home</Link>
                    <Link to="/">Help</Link>
                    <Link to="/">FAQs</Link>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        {/* Footer End */}
      </div>
    );
  }
}

export default Footer;